(() => {
    'use strict';

    if (!real.dom.$body.hasClass('login-entra-id-signup')) {
        return;
    }

    $('.close-btn').on('click', () => {
        window.close();
    });
})();
